/* eslint-disable @typescript-eslint/no-unused-vars */
import { useCallback } from 'react'
import { Handle, Position } from '@xyflow/react'
import brokerLogo from '@/assets/hivemq-enterprise-vert.png'

const handleStyleLeft = { left: -2, top: 70 }
const handleStyleTop1 = { left: 20 }
const handleStyleTop2 = { left: 140 }
const handleStyleBottom1 = { left: 20 }
const handleStyleBottom2 = { left: 140 }

function EntBrokerNode({ data, isConnectable }) {
  const onChange = useCallback((evt) => {}, [])

  return (
    <div className="custom-node ent-limits">
      <Handle type="target" position={Position.Left} />

      <div className="grid grid-cols-2">
        <div className="mr-2">
          <div>
            <a href={import.meta.env.VITE_CENTRAL_CC_ADDRESS} target="_blank" rel="noreferrer">
              <img src={brokerLogo} alt="HiveMQ Ent Logo" className="custom-node-broker-logo" />
            </a>
          </div>
        </div>
        <div>
          <div>
            <b>Security</b>
          </div>
          <div>
            <b>Bridge</b>
          </div>
          <div>
            <b>Database</b>
          </div>
          <div>
            <b>Streaming</b>
          </div>
          <div>
            <b>Data Hub</b>
          </div>
        </div>
      </div>

      <Handle id="a" type="source" position={Position.Top} style={handleStyleTop1} />
      <Handle id="b" type="source" position={Position.Top} style={handleStyleTop2} />
      <Handle id="c" type="source" position={Position.Right} />
      <Handle id="d" type="source" position={Position.Bottom} style={handleStyleBottom1} />
      <Handle id="e" type="source" position={Position.Bottom} style={handleStyleBottom2} />
    </div>
  )
}

export default EntBrokerNode
